module.exports = __webpack_public_path__ + "img/thicon.c20872dd.png";